import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrimeiroAcessoComponent } from './components/usuario/primeiro-acesso/primeiro-acesso.component';

/**
 * Módulo que possui as rotas da aplicação
 */
const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),
  },
  { path: 'usuarios/cadastrar', 
    component: PrimeiroAcessoComponent 
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
